import { Region } from './region';
export var Language;
(function (Language) {
    Language["en"] = "en";
    Language["id"] = "id";
    Language["ja"] = "ja";
    Language["ms"] = "ms";
    Language["th"] = "th";
    Language["vi"] = "vi";
    Language["fil"] = "fil";
})(Language || (Language = {}));
export const LanguageDisplayNameMap = {
    en: 'English',
    id: 'Bahasa Indonesia',
    ja: '日本語',
    ms: 'Bahasa Melayu',
    th: 'ไทย',
    vi: 'Tiếng Việt',
    fil: 'Pilipino',
};
export const RegionFallbackLanguageMap = {
    [Region.jp]: Language.ja,
    [Region.th]: Language.th,
    [Region.my]: Language.ms,
    [Region.id]: Language.id,
    [Region.vn]: Language.vi,
    [Region.us]: Language.en,
    [Region.gb]: Language.en,
    [Region.sg]: Language.en,
    [Region.ph]: Language.en,
};
export const RegionHrefLangMap = {
    [Region.jp]: 'ja-jp',
    [Region.th]: 'th-th',
    [Region.my]: 'ms-my',
    [Region.id]: 'id-id',
    [Region.vn]: 'vi-vn',
    [Region.us]: 'en-us',
    [Region.gb]: 'en-gb',
    [Region.sg]: 'en-sg',
    [Region.ph]: 'en-ph',
};
//# sourceMappingURL=language.js.map